import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppSharedModule } from 'app/app-shared.module';
import {
  AuthGuardService,
  NotExecutiveGuardService,
  AccountFeatureGuardService,
} from 'app/providers/bridge-api/auth.service';
import { GroupRouteGuardService } from 'app/services/group-route-guard.service';
import { ActionItemListFilterComponent } from './components/action-item-list-filter/action-item-list-filter.component';
import { ActionPlanDetailsItemsTabComponent } from './components/action-plan-details-items-tab/action-plan-details-items-tab.component';
import { ActionPlanDetailsProgressTabComponent } from './components/action-plan-details-progress-tab/action-plan-details-progress-tab.component';
import { ActionPlanDetailsTasksTabComponent } from './components/action-plan-details-tasks-tab/action-plan-details-tasks-tab.component';
import { ActionPlanSettingsDrawerComponent } from './components/action-plan-settings-drawer/action-plan-settings-drawer.component';
import { ActionPlanTableComponent } from './components/action-plan-table/action-plan-table.component';
import { CreateActionItemDialogComponent } from './components/create-action-item-dialog/create-action-item-dialog.component';
import { CreateActionPlanDialogComponent } from './components/create-action-plan-dialog/create-action-plan-dialog.component';
import { CreateActionTaskDialogComponent } from './components/create-action-task-dialog/create-action-task-dialog.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ProgressWidgetComponent } from './components/progress-widget/progress-widget.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import { StatusProgressViewComponent } from './components/status-progress-view/status-progress-view.component';
import { ActionPlanDetailsComponent } from './pages/action-plan-details/action-plan-details.component';
import { ActionPlanListComponent } from './pages/action-plan-list/action-plan-list.component';

@NgModule({
  imports: [
    AppSharedModule,
    NgbModule,

    RouterModule.forRoot(
      [
        {
          canActivate: [
            AuthGuardService,
            NotExecutiveGuardService,
            GroupRouteGuardService,
            AccountFeatureGuardService,
          ],
          path: 'groups/:groupId/action-plans',
          component: ActionPlanListComponent,
          data: { feature: 'ACTION_PLANS' },
        },
        {
          canActivate: [
            AuthGuardService,
            NotExecutiveGuardService,
            GroupRouteGuardService,
            AccountFeatureGuardService,
          ],
          path: 'groups/:groupId/action-plans/:actionPlanId',
          component: ActionPlanDetailsComponent,
          data: { feature: 'ACTION_PLANS' },
        },
      ],
      {}
    ),
  ],
  declarations: [
    ActionPlanListComponent,
    ActionPlanDetailsComponent,
    PaginatorComponent,
    StatusLabelComponent,
    ActionPlanSettingsDrawerComponent,
    ActionPlanDetailsProgressTabComponent,
    ActionPlanDetailsItemsTabComponent,
    ActionPlanDetailsTasksTabComponent,
    ActionItemListFilterComponent,
    CreateActionPlanDialogComponent,
    CreateActionItemDialogComponent,
    CreateActionTaskDialogComponent,
    ProgressWidgetComponent,
    StatusProgressViewComponent,
    ActionPlanTableComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CreateActionPlanDialogComponent,
    CreateActionItemDialogComponent,
    CreateActionTaskDialogComponent,
    ActionPlanTableComponent,
  ],
})
export class ActionPlanModule {}
